export default __webpack_public_path__ + "static/media/metamask.212e2ce7.png";